module.exports = __webpack_public_path__ + "static/davidgraham-2a19cc6dd3186675401a2e2cccff1679.jpg";